import { useTranslation } from 'react-i18next'

import { NAVIGATION } from 'constant/config'

import { useModal } from 'context/ModalContext'

// import Reference from 'components/Reference'
import Button from 'components/Button'
import Login from 'modules/Modals/Login'

import style from './index.module.scss'

const Account = () => {
  const { t } = useTranslation()
  const { openModal } = useModal()

  return (
    <div className={style.block}>
      {/*<Reference*/}
      {/*  to={t(NAVIGATION.registration.url)}*/}
      {/*  classes={['secondary', 'md']}*/}
      {/*  placeholder={t(NAVIGATION.registration.text)}*/}
      {/*/>*/}
      <Button
        classes={['primary', 'md']}
        placeholder={t(NAVIGATION.login.text)}
        onChange={() =>
          openModal({
            title: t('sign_up'),
            body: <Login />
          })
        }
      />
    </div>
  )
}

export default Account
